var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_197_2",
    "data-name": "Component 197 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7652",
    "data-name": "Rectangle 7652",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-ad-svgrepo-com",
    transform: "translate(4.5 5.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50757",
    "data-name": "Path 50757",
    d: "M17.741,9.05H5V4.5H17.741Z",
    transform: "translate(-0.315 -0.315)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50758",
    "data-name": "Path 50758",
    d: "M5,14h5.46",
    transform: "translate(-0.315 -1.169)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50759",
    "data-name": "Path 50759",
    d: "M5,18H9.1",
    transform: "translate(-0.315 -1.529)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50760",
    "data-name": "Path 50760",
    d: "M8.781,21.021H3.32A1.82,1.82,0,0,1,1.5,19.2V2.82A1.82,1.82,0,0,1,3.32,1H18.791a1.82,1.82,0,0,1,1.82,1.82V8.736",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50761",
    "data-name": "Path 50761",
    d: "M17.55,22.1A4.55,4.55,0,1,0,13,17.55a4.55,4.55,0,0,0,4.55,4.55Z",
    transform: "translate(-1.034 -1.079)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50762",
    "data-name": "Path 50762",
    d: "M18,16v3.64",
    transform: "translate(-1.484 -1.349)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50763",
    "data-name": "Path 50763",
    d: "M16,18h3.64",
    transform: "translate(-1.304 -1.529)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.d4e04a3579078fe1a6ea965198f688f1.svg";
export { ForwardRef as ReactComponent };